import ReactDOM from 'react-dom/client'
import App from './App'
import { ToastContainer } from 'react-toastify'
import AuthProvider from './contexts/authContext'
import reportWebVitals from './reportWebVitals'
import 'react-confirm-alert/src/react-confirm-alert.css'
import './assets/sass/index.scss'
import { ThemeProvider, createTheme } from '@mui/material'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
const theme = createTheme({
    typography: {
        'fontFamily': 'Open Sans'
    }
})

root.render(
    <ThemeProvider theme={theme}>
        <AuthProvider>
            <App />
            <ToastContainer />
        </AuthProvider>
    </ThemeProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
